var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVotingBox = function SvgVotingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.333,
    height: 85.333,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m53.2 12.7-3.3 2.6-3.8-2.1c-3.3-1.9-5.4-2.2-15.3-2.2-10.3 0-11.9.2-14.8 2.2-6.2 4.2-7.4 6.9-7.8 17.2-.5 10.2.7 15.6 4.2 19.4 3.9 4.4 6.8 5.2 18.3 5.2 12.7 0 16.5-1.4 20.1-7.6 2.1-3.6 2.2-5 2-16.1L52.6 19l3.3-3.4c1.8-1.9 3-3.9 2.7-4.5-1-1.6-1.7-1.3-5.4 1.6zM40 14c7 2 7 2.2-2.1 10.9l-8.4 8-4-3.1c-2.2-1.7-4.5-3.5-5.1-4-.7-.5-2.1-.1-3.5 1.1l-2.4 2 9 9c4.9 5 9.2 9.1 9.5 9.1.3 0 2-2.8 3.7-6.3 1.8-3.4 5.4-8.9 8-12.2l4.8-6 .3 9.4C50.3 47.8 46.3 52 30.7 52c-9.6 0-13.1-1.2-16.6-5.6-1.8-2.4-2.1-4-2.1-14 0-10.6.1-11.4 2.6-14.3 1.4-1.7 4-3.5 5.7-4 4.4-1.3 15.4-1.3 19.7-.1z",
    fill: "currentColor"
  })));
};

export default SvgVotingBox;